import React from 'react';
import { Modal } from '../../ui/Modal';
import { useConversationPalette } from '../../conversation/ConversationTheme';

interface EndingCountdownModalProps {
  open?: boolean;
  countdown: number;
  /** Starting value of the countdown, drives the ring's full-to-empty sweep. */
  total?: number;
  onCancel: () => void;
}

export const EndingCountdownModal: React.FC<EndingCountdownModalProps> = ({ open = true, countdown, total = 3, onCancel }) => {
  const palette = useConversationPalette();
  return (
    // dismissible=false: this is a small modal and a stray backdrop/Escape tap
    // would otherwise be routed to onCancel and read as "continue the interview".
    // The only way out is the explicit "Keep going" button below.
    <Modal open={open} onClose={onCancel} dismissible={false}>
      <div className="text-center space-y-6">
        {/* Countdown Circle */}
        <div className="mx-auto relative w-24 h-24 flex items-center justify-center">
          <svg className="w-24 h-24 absolute transform -rotate-90">
            <circle
              cx="48"
              cy="48"
              r="44"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              className="text-ink"
            />
            <circle
              cx="48"
              cy="48"
              r="44"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              className={palette ? 'text-accent-soft' : 'text-success'}
              strokeDasharray={276.46}
              strokeDashoffset={276.46 * (1 - countdown / total)}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 1s linear' }}
            />
          </svg>
          <span className="text-4xl font-bold text-foreground z-10">{countdown}</span>
        </div>

        {/* Content - countdown circle carries the "ending" state visually; copy stays minimal. */}
        <div>
          <p className="text-muted-foreground">
            hollie is wrapping up.
          </p>
        </div>

        {/* Cancel Button */}
        <button
          onClick={onCancel}
          className="block w-full bg-surface hover:bg-surface-hover text-foreground font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          Keep going
        </button>
      </div>
    </Modal>
  );
};
